// module.exports = file => () => import('@/views/' + file + '.vue')
module.exports = file => () => import('@/views/' + file)



// WEBPACK FOOTER //
// ./src/router/_import_production.js